import {
  TradeOrderStatus,
  TradeSide,
  TradeStrategy,
  C2COrderStatus,
  C2COrderType,
  WyreOrderStatus
} from "@foxone/api/src/models/market";
import { Colors } from "@/types";

const AutoTradeStatusMeta = {
  [TradeOrderStatus.CANCELLED]: {
    text: "trade.enum.order-status.cancelled",
    color: Colors.RED
  },
  [TradeOrderStatus.PAID]: {
    text: "trade.enum.order-status.paid",
    color: Colors.WARNING
  },
  [TradeOrderStatus.CANCELING]: {
    text: "trade.enum.order-status.canceling",
    color: Colors.RED
  },
  [TradeOrderStatus.FILLED]: {
    text: "trade.enum.order-status.filled",
    color: Colors.GREEN
  },
  [TradeOrderStatus.PENDING]: {
    text: "trade.enum.order-status.pending",
    color: Colors.WARNING
  },
  [TradeOrderStatus.REJECTED]: {
    text: "trade.enum.order-status.rejected",
    color: Colors.RED
  },
  [TradeOrderStatus.TIMEOUT]: {
    text: "trade.enum.order-status.timeout",
    color: Colors.RED
  },
  [TradeOrderStatus.TRADING]: {
    text: "trade.enum.order-status.trading",
    color: Colors.WARNING
  }
};

const TradeSideMeta = {
  [TradeSide.ASK]: {
    text: "trade.enum.trade-side.ask",
    color: Colors.RED
  },
  [TradeSide.BID]: {
    text: "trade.enum.trade-side.bid",
    color: Colors.GREEN
  }
};

const TradeStrategyMeta = {
  [TradeStrategy.MARKET]: {
    text: "trade.enum.trade-strategy.market"
  },
  [TradeStrategy.FLEX]: {
    text: "trade.enum.trade-strategy.flex"
  }
};

const TradeStrategyLimitMeta = {
  [TradeSide.ASK]: {
    text: "trade.enum.trade-strategy-limit.ask"
  },
  [TradeSide.BID]: {
    text: "trade.enum.trade-strategy-limit.bid"
  }
};

const TradeStrategyChangeMeta = {
  [TradeSide.ASK]: {
    text: "trade.enum.trade-strategy-change.ask"
  },
  [TradeSide.BID]: {
    text: "trade.enum.trade-strategy-change.bid"
  }
};

const C2COrderStatusMeta = {
  [C2COrderStatus.OTCPending]: {
    text: "trade.enum.c2c-order-status.otc-pending",
    color: Colors.WARNING
  },
  [C2COrderStatus.OTCPaid]: {
    text: "trade.enum.c2c-order-status.otc-paid",
    color: Colors.WARNING
  },
  [C2COrderStatus.OTCDone]: {
    text: "trade.enum.c2c-order-status.otc-done",
    color: Colors.WARNING
  },
  [C2COrderStatus.OTCPaidCancelled]: {
    text: "trade.enum.c2c-order-status.otc-paid-cancelled",
    color: Colors.RED
  },
  [C2COrderStatus.OTCPaidConfirmed]: {
    text: "trade.enum.c2c-order-status.otc-paid-confirmed",
    color: Colors.WARNING
  },
  [C2COrderStatus.OTCUnpaidCancelled]: {
    text: "trade.enum.c2c-order-status.otc-unpaid-cancelled",
    color: Colors.RED
  },
  [C2COrderStatus.ATMCancelled]: {
    text: "trade.enum.c2c-order-status.atm-cancelled",
    color: Colors.RED
  },
  [C2COrderStatus.ATMFilled]: {
    text: "trade.enum.c2c-order-status.atm-filled",
    color: Colors.GREEN
  },
  [C2COrderStatus.ATMPending]: {
    text: "trade.enum.c2c-order-status.atm-pending",
    color: Colors.WARNING
  },
  [C2COrderStatus.ATMRejected]: {
    text: "trade.enum.c2c-order-status.atm-rejected",
    color: Colors.RED
  },
  [C2COrderStatus.ATMTimeout]: {
    text: "trade.enum.c2c-order-status.atm-timeout",
    color: Colors.RED
  },
  [C2COrderStatus.ATMTrading]: {
    text: "trade.enum.c2c-order-status.atm-trading",
    color: Colors.WARNING
  }
};

const C2COrderTypeMeta = {
  [C2COrderType.HFOX]: {
    text: "trade.enum.c2c-order-type.hfox"
  },
  [C2COrderType.ATM]: {
    text: "trade.enum.c2c-order-type.atm"
  }
};

const WyreOrderStatusMeta = {
  [WyreOrderStatus.COMPLETE]: {
    text: "common.completed",
    color: Colors.GREEN
  },
  [WyreOrderStatus.FAILED]: {
    text: "common.failed",
    color: Colors.RED
  },
  [WyreOrderStatus.PROCESSING]: {
    text: "common.processing",
    color: Colors.WARNING
  },
  [WyreOrderStatus.RUNNING_CHECKS]: {
    text: "common.running-checks",
    color: Colors.WARNING
  }
};

export default {
  getAutoTradeStatusMeta(status: TradeOrderStatus) {
    return AutoTradeStatusMeta[status];
  },

  getTradeSideMeta(side: TradeSide) {
    return TradeSideMeta[side];
  },

  getTradeStrategyMeta(strategy: TradeStrategy) {
    return TradeStrategyMeta[strategy];
  },

  getTradeStrategyLimitMeta(side: TradeSide) {
    return TradeStrategyLimitMeta[side];
  },

  getTradeStrategyChangeMeta(side: TradeSide) {
    return TradeStrategyChangeMeta[side];
  },

  getC2COrderStatusMeta(status: C2COrderStatus) {
    return C2COrderStatusMeta[status];
  },

  getC2COrderTypeMeta(type: C2COrderType) {
    return C2COrderTypeMeta[type];
  },

  getWyreStatusMeta(status: WyreOrderStatus) {
    return WyreOrderStatusMeta[status];
  }
};
